import {
  AdPlacement,
  PlacementId,
  UNLEASH_FEATURE_NAME
} from '@schibsted-nmp/advertising-shared';

import { isFeatureEnabled } from '../state/reducer';

/**
 * Threshold is how far the viewport is within the container
 * rootMargin is how far away the viewport is from the container
 *
 * All placement will have different optimal settings.
 * Sometimes it might even differ per brand
 *
 * @param placementId
 */
export function getInViewSettingsByPlacementId(placementId: PlacementId) {
  // feature flag here
  const experimentalRootMarginsEnabled = isFeatureEnabled(
    UNLEASH_FEATURE_NAME.enableExperimentalRootMargins
  );

  if (experimentalRootMarginsEnabled) {
    // If feature is true
    switch (placementId) {
      case AdPlacement.Top2.id: {
        return {
          threshold: 0.0,
          rootMargin: '0px'
        };
      }
      case AdPlacement.Top1.id: {
        return {
          threshold: 0.0,
          rootMargin: '0px'
        };
      }
      case AdPlacement.Middle1.id: {
        return {
          threshold: 0.0,
          rootMargin: '200px 0px 200px 0px'
        };
      }
      case AdPlacement.Middle2.id: {
        return {
          threshold: 0.0,
          rootMargin: '400px'
        };
      }
      case AdPlacement.RecircMiddle1.id: {
        return {
          threshold: 0.0,
          rootMargin: '200px'
        };
      }
      case AdPlacement.RecircMiddle2.id: {
        return {
          threshold: 0.0,
          rootMargin: '200px'
        };
      }
      case AdPlacement.Bottom1.id: {
        return {
          threshold: 0.0,
          rootMargin: '400px'
        };
      }
      default: {
        return {
          threshold: 0.0,
          rootMargin: '0px'
        };
      }
    }
  } else
    return {
      threshold: 0.0,
      rootMargin: '0px'
    };
}
